export const initialAbility = [
  {
    subject: 'Public',
    action: 'read',
  },
]

export const _ = undefined
